import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaAgentSearchContextInterface } from '../schema/agent-search-context.interface';

export class Snowplow2StatsAdapterSchemaAgentSearchContext implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaAgentSearchContextInterface {
    if (!this.context.global.agent_search) {
      throw new Error('Stats context "agent_search" is not set.');
    }

    const schema: Snowplow2StatsSchemaAgentSearchContextInterface = {
      schema: 'iglu:ae.propertyfinder/agent_search_context/jsonschema/1-0-1',
      data: {},
    };

    // Keywords
    if (this.context.global.agent_search.text !== undefined) {
      schema.data.keywords = this.context.global.agent_search.text;
    }

    // Service needed
    if (this.context.global.agent_search.category_id !== undefined) {
      schema.data.service_needed = String(this.context.global.agent_search.category_id);
    }

    // Language
    if (this.context.global.agent_search.language_ids !== undefined) {
      schema.data.language = this.context.global.agent_search.language_ids.map((language) => String(language));
    }

    // Nationality
    if (this.context.global.agent_search.nationality_id !== undefined) {
      schema.data.nationality = this.context.global.agent_search.nationality_id;
    }

    // Location
    if (this.context.global.agent_search.location_id !== undefined) {
      schema.data.location = String(this.context.global.agent_search.location_id);
    }

    // Agent
    if (this.context.global.agent_search.agent_id !== undefined) {
      schema.data.agent_id = this.context.global.agent_search.agent_id;
    }

    return schema;
  }
}
